module.exports = __webpack_public_path__ + "img/31.21c0cc66.jpg";